import Cookies from 'js-cookie'
import { CookieKeys } from 'types/cookies'
import { PORTAL_URL } from 'constants/constants'

/**
 * Checks if the user is a sales user and if they are authenticated. Non-authenticated sales user will get redirected back to sales portal.
 * @param {string} partnerId
 * @returns {{isSalesUser: boolean, authenticated: boolean}}
 */
export const checkAndHandleSalesUser = (
  partnerId?: string
): {
  isSalesUser: boolean
  authenticated?: boolean
} => {
  const salesAccessToken = Cookies.get(CookieKeys.SALES_ACCESS_COOKIE_NAME)
  const isAuthenticated = partnerId ? !!salesAccessToken : undefined

  // Redirect non-authenticated sales user back to sales portal with sessionExpired flag
  if (partnerId && !isAuthenticated) {
    window.open(`${PORTAL_URL}/sales/events?sessionExpired=true`, '_self')?.focus()
  }

  return {
    isSalesUser: !!partnerId,
    authenticated: !partnerId ? undefined : !!salesAccessToken
  }
}
